<template>
    <a :href="href" @click.prevent="click">
        <slot></slot>
    </a>
</template>

<script>
export default {
    name: 'RouterLink',
    props: {
        payload: Object,
    },
    computed: {
        href() {
            return `/${this.$router.href(this.payload)}`;
        },
    },
    methods: {
        click(e) {
            e.preventDefault();
            setTimeout(() => {
                this.$router.push(this.payload);
            }, 0);
        },
    },
};
</script>

<style scoped>
a {
    color: rgb(var(--v-theme-primary)) !important;
}
</style>
